import React from 'react';

/**
 * Renderiza el bloque OxygenChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function OxygenChart({
  v
}) {
  return React.createElement("div", {
    className: "scapp-detail-chart-row",
    style: {
      "display": v.showEnvironment ? "grid" : "none",
      "gridTemplateColumns": "13.541667vw 2.291667vw minmax(0,1fr) 4.791667vw",
      "gap": "0",
      "alignItems": "center"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "paddingRight": "0.208333vw"
    }
  }, React.createElement("button", {
    type: "button",
    "data-detail-legend": "oxygen",
    "aria-pressed": v.showOxygenSeries,
    onClick: () => v.toggleDetailMetric("oxygen"),
    style: {
      "display": v.hasOxygen ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showOxygenSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.78 0.11 220)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text("Oxígeno [" + (v.det.oxygenUnit || "%") + "]")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.78 0.11 220)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vO))), React.createElement("button", {
    type: "button",
    "data-detail-legend": "temperature",
    "aria-pressed": v.showTemperatureSeries,
    onClick: () => v.toggleDetailMetric("temperature"),
    style: {
      "display": v.hasTemperature ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showTemperatureSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.74 0.13 340)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text("Temp. [°C]")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.74 0.13 340)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vTe)))), React.createElement("div", {
    "onMouseMove": v.hMove,
    "onMouseLeave": v.hLeave,
    "onMouseDown": v.hDown,
    "onMouseUp": v.hUp,
    "onWheel": v.hWheel,
    "data-wheel-zoom": "1",
    style: {
      "gridColumn": "3",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "cursor": v.hCursor,
      "userSelect": "none"
    }
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none"
    }
  }, (v.det.axEnvironment || []).map((t, index23) => React.createElement(React.Fragment, {
    key: index23
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": t.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.13)"
    }
  }, null)))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "-2.291667vw",
      "width": "2.291667vw",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showOxygenSeries ? "block" : "none",
      "borderRight": "0.052083vw solid oklch(0.78 0.11 220 / 0.55)"
    }
  }, (v.det.axO || []).map((t, index24) => React.createElement(React.Fragment, {
    key: index24
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.78 0.11 220)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.78 0.11 220)"
    }
  }, v.text(t.lab))))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "calc(100% + 0vw)",
      "width": "2.395833vw",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showTemperatureSeries ? "block" : "none",
      "borderLeft": "0.052083vw solid oklch(0.74 0.13 340 / 0.55)"
    }
  }, (v.det.axTe || []).map((t, index25) => React.createElement(React.Fragment, {
    key: index25
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.74 0.13 340)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.74 0.13 340)"
    }
  }, v.text(t.lab))))), React.createElement("svg", {
    "viewBox": v.zVB,
    "preserveAspectRatio": "none",
    style: {
      "width": "100%",
      "height": v.dH.o / 10.8 + "vh",
      "display": "block",
      "background": "rgba(4,12,24,0.55)",
      "borderRadius": "0.37037vh"
    }
  }, React.createElement("path", {
    "d": v.czSpan,
    "fill": "oklch(0.66 0.19 42 / 0.16)",
    "stroke": "none"
  }, null), React.createElement("path", {
    "d": v.det.oxy,
    "display": v.showOxygenSeries ? "inline" : "none",
    "stroke": "oklch(0.78 0.11 220)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null), React.createElement("path", {
    "d": v.det.temp,
    "display": v.showTemperatureSeries ? "inline" : "none",
    "stroke": "oklch(0.74 0.13 340)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null)), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.hx,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.55",
      "pointerEvents": "none",
      "display": v.hDisp
    }
  }, null), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.selL,
      "width": v.selW,
      "background": "rgba(228,233,240,0.12)",
      "borderLeft": "0.052083vw solid #8793a6",
      "borderRight": "0.052083vw solid #8793a6",
      "pointerEvents": "none",
      "display": v.selD
    }
  }, null)));
}
